var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBardashboardcardpuspenerbal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 12,
    viewBox: "0 0 141 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_784)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.5,
    height: 12,
    fill: "#18A0FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123 0H112.5V12H115L123 0ZM125 0L117 12H121L129 0H125ZM123 12L131 0H135L127 12H123ZM141 0H137L129 12H133L141 0Z",
    fill: "#18A0FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBardashboardcardpuspenerbal);
export default __webpack_public_path__ + "static/media/bardashboardcardpuspenerbal.50a5de90a43e26c72c96a27f0ec5e0e4.svg";
export { ForwardRef as ReactComponent };